// extracted by mini-css-extract-plugin
module.exports = {"contactCard":"ContentRenderer_contactCard__EKseh","renderer":"ContentRenderer_renderer__tPJbs","body":"ContentRenderer_body__XLXHl"};